import React, {forwardRef, useState} from "react";
import DatePicker, {registerLocale} from "react-datepicker";
import {TextField} from "features/components/text-field";
import {bool, func, object, oneOfType, string} from "prop-types";
import "react-datepicker/dist/react-datepicker.min.css";
import "./index.scss";
import {Icon} from "features/components/icon";
import it from 'date-fns/locale/it';
import moment, {ISO_8601} from "moment";
registerLocale('it', it);


const DatePickerComponent = (props) => {
    const {onChange, placeholder, disabled, dateFormat, yearPicker} = props;
    const [dateVal, setDate] = useState(props.value);
    React.useEffect(() => {
        onChange(dateVal);
    }, [onChange, dateVal]);
    /* istanbul ignore next */
    const CustomInput = forwardRef(({value, onClick}, ref) => {
        return <div ref={ref} onClick={onClick}>
            <TextField
                type={"text"}
                value={dateVal}
                onChange={() => {}}
                placeholder={placeholder}
                disabled={disabled}
            />
        </div>
    });
    /* istanbul ignore next */
    return <div className={"date-picker"}>
        <DatePicker
            onChange={(val) => setDate(moment(val, ISO_8601).format(dateFormat))}
            customInput={<CustomInput />}
            showYearDropdown={true}
            showYearPicker={!!yearPicker}
            dateFormat="dd/MM/yyyy"
            locale="it"
        />
        <Icon>calendar</Icon>
    </div>

};

DatePickerComponent.propTypes = {
    placeholder: oneOfType([string, object]),
    date: string,
    onChange: func.isRequired,
    disabled: bool,
    dateFormat:string.isRequired,
    yearPicker: bool
};

export default DatePickerComponent;